import { Strings } from './Strings';

export const getDeGeStrings = () : Strings => ({
  SESSION_EXPIRED: 'Sitzung abgelaufen!',
  BOOLEAN_ATTRIBUTE_YES: 'Ja',
  BOOLEAN_ATTRIBUTE_NO: 'Nein',
  PAGE_NOT_FOUND: 'Seite nicht gefunden...',
  COLLECTIONS_HEADER_LABEL: 'Sammlungen',
  SEARCH_HEADER_LABEL: 'Suchen',
  INFORMATION_SLIDER_BUTTON: '+ INFORMATIONEN',
  NEXT_SLIDER_SPAN: 'Nächste',
  PREVIOUS_SLIDER_SPAN: 'Vorherige',
  SPOTLIGHT_OBJECTS_LABEL: 'Maßgeschneiderte Reitstiefel, exklusiv für Sie hergestellt.',
  MENU_FOOTER_LABEL: 'Speisekarte',
  FILTERS_LABEL: 'Filter',
  VARIANTS_OBJECT_LABEL: 'Varianten',
  ADD_TO_CART_OBJECT_LABEL: 'In den Warenkorb legen',
  PRODUCT_LIST_ORDER_LABEL: 'PRODUKTLISTE',
  ORDER_TOTAL_LABEL: 'Gesamtsumme im Warenkorb',
  CHECKOUT_ORDER_BUTTON: 'WEITER ZUR KASSE',
  PREVIEW_ORDER_BUTTON: 'Bestellvorschau',
  VARIANT_ORDER_ITEM_LABEL: 'Variante',
  QUANTITY_ORDER_ITEM_LABEL: 'Menge',
  PRODUCT_ADDED_TOAST_LABEL: 'Produkt hinzugefügt!',
  CHECKOUT_ORDER_TOAST_LABEL: 'Anfrage geschickt!',
  COMPONENTS_OBJECT_LABEL: 'Komponenten',
  ORDER_DETAIL_TITLE_LABEL: 'Bestelldetails',
  ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL: 'Benutzerdefinierte Attribute',
  SUBMIT_LABEL: 'Einreichen',
  ADD_TO_CART_LABEL: 'Artikel zum Warenkorb hinzufügen',
  CUSTOMIZED_VARIANT: 'Maßgeschneidert',
  PRODUCTLIST: 'Produktliste',
  PRODUCTLISTDOCLABEL_ITEMNAME: 'Artikelname',
  PRODUCTLISTDOCLABEL_VARIATION: 'Variation',
  PRODUCTLISTDOCLABEL_COLLECTION: 'Sammlung',
  PRODUCTLISTDOCLABEL_COMPOSITION: 'Komposition',
  PRODUCTLISTDOCLABEL_QUANTITY: 'Menge',
  NAVIGATE_BACK: 'Geh zurück',
  REMOVE: 'Entfernen',
  CLEAR_CART: 'Warenkorb leeren',
  RESULTS_FOR: 'Ergebnisse für',
  NO_CONTENT_TEXT: 'Bild nicht verfügbar',
  STANDARD: 'Standard',
  PARTS: 'Teile',
  CUSTOMIZATIONS: 'Anpassungen',
  PRICE: 'Preis',
  TOTAL: 'Gesamt',
  QUANTITY: 'Menge',
  MEASURES: 'Maßnahmen',
  CUSTOM_ATTRIBUTES: 'Benutzerdefinierte Attribute',
  LOGIN_SUCCESSFUL: 'Anmeldung erfolgreich',
  LOGIN_CREDENTIALS_NOT_VALID: 'Anmeldeinformationen ungültig',
  LOGIN_UNKNOWN_ERROR: 'Unbekannter Fehler',
  LOGIN_RECOVER_PASSWORD: 'Passwort wiederherstellen',
  LOGIN_CHANGE_PASSWORD: 'Kennwort ändern',
  LOGIN_USERNAME: 'Nutzername',
  LOGIN_PASSWORD: 'Passwort',
  LOGIN_OLD_PASSWORD: 'Altes Kennwort',
  LOGIN_NEW_PASSWORD: 'Neues Kennwort',
  LOGIN_NEW_PASSWORD_REPEAT: 'Wiederhole das neue Passwort',
  LOGIN_ACTION_LOGIN: 'Anmeldung',
  RECOVER_PASSWORD_MESSAGE: 'Ein neues Passwort wurde an Ihre E-Mail-Adresse gesendet.',
  CHANGE_PASSWORD_SUCCESSFUL_MESSAGE: 'Die Passwortänderung war erfolgreich.',
  CHANGE_PASSWORD_ERROR_MESSAGE: 'Beim Versuch, das Passwort zu ändern, ist ein Fehler aufgetreten.',
  CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE: 'Das neue Passwort muss mit der neuen Passwortreparatur übereinstimmen.',
  GO_BACK_ACTION: 'Zurück',
  CONFIRM_ACTION: 'Bestätigen',
  SIGN_OUT_ACTION: 'Abmelden',
  OK_ACTION: 'OK',
  CANCEL_ACTION: 'Stornieren',
  RETRY_ACTION: 'Wiederholen',
  RESEND_ACTION: 'Erneut senden',
  ERROR_LABEL: 'Fehler',
  SUCCESS_LABEL: 'Erfolg',
  ORDER_ERROR_MESSAGE: 'Beim Absenden der Bestellung ist ein Fehler aufgetreten.',
  ORDER_SUCCESS_MESSAGE: 'Das Absenden der Bestellung war erfolgreich.',
  DEMO_ORDER_ERROR_MESSAGE: 'Bestellvorgang im Demonstrationsmodus erfolgreich abgeschlossen.',
  DEMO_ORDER_SUCCESS_MESSAGE: 'Bestellvorgang im Demonstrationsmodus erfolgreich abgeschlossen.',
  VALIDATION_POP_UP_TITLE: 'E-Mail-Validierung',
  VALIDATION_POP_UP_MESSAGE: 'Bitte geben Sie den an Ihre E-Mail-Adresse gesendeten Code ein:',
  VALIDATION_POP_UP_ERROR: 'Code stimmt nicht überein',
  DEMO_WARNING: 'Nur zu Demonstrationszwecken!',
  REPORT_ORDER_INFO_TITLE: 'Bestelldaten',
  REPORT_TITLE_DESCRIPTION: 'Beschreibung',
  REPORT_TITLE_VALUE: 'Wert',
  REPORT_TITLE_QUANTITY: 'Menge',
  REPORT_TITLE_PRICE: 'Preis',
  REPORT_TITLE_SCREENSHOT: 'Bildschirmfoto',
  REPORT_TITLE_KEY: 'Name',
});
